export const rules = {
    number: {
        equals: {
            code: 301,
            label: 'equals'
        },
        between: {
            code: 302,
            label: 'between'
        },
        more: {
            code: 303,
            label: 'more'
        },
        less: {
            code: 304,
            label: 'less'
        },
        noValue: {
            code: 305,
            label: 'has_no_value'
        }
    },
    text: {
        equals: {
            code: 101,
            label: 'equals'
        },
        contain: {
            code: 102,
            label: 'contain'
        },
        empty: {
            code: 103,
            label: 'empty'
        },
        notEmpty: {
            code: 104,
            label: 'not_empty'
        }
    },
    textarea: {
        equals: {
            code: 201,
            label: 'equals'
        },
        contain: {
            code: 202,
            label: 'contain'
        },
        empty: {
            code: 203,
            label: 'empty'
        },
        notEmpty: {
            code: 204,
            label: 'not_empty'
        }
    },
    check: {
        equals: {
            code: 501,
            label: 'equals'
        }
    },
    linkedField: {
        is: {
            code: 601,
            label: 'is'
        },
        anyValue: {
            code: 602,
            label: 'has_any_value'
        },
        noValue: {
            code: 603,
            label: 'has_no_value'
        }
    },
    datetime: {
        equals: {
            code: 401,
            label: 'equals'
        },
        between: {
            code: 402,
            label: 'between'
        },
        isAfter: {
            code: 403,
            label: 'is_after'
        },
        isBefore: {
            code: 404,
            label: 'is_before'
        },
        noValue: {
            code: 405,
            label: 'has_no_value'
        }
    },
    formula: {
        equals: {
            code: 701,
            label: 'equals'
        },
        between: {
            code: 702,
            label: 'between'
        },
        more: {
            code: 703,
            label: 'more'
        },
        less: {
            code: 704,
            label: 'less'
        },
        invalid: {
            code: 705,
            label: 'invalid'
        }
    },
	email: {
        equals: {
            code: 201,
            label: 'equals'
        },
        contain: {
            code: 202,
            label: 'contain'
        },
        empty: {
            code: 203,
            label: 'empty'
        },
        notEmpty: {
            code: 204,
            label: 'not_empty'
        }
    },
}

export const logicalValues = {
    indeterminate: {
        code: '-',
        label: 'indeterminate'
    },
    disabled: {
        code: '0',
        label: 'disabled'
    },
    enabled: {
        code: '1',
        label: 'enabled'
    }
}

export const dateTypes = {
    exact: {
        code: 1,
        label: 'exact_date'
    },
    today: {
        code: 2,
        label: 'today'
    },
    period: {
        code: 3,
        label: 'period'
    },
    monthstart: {
        code: 4,
        label: 'month_start'
    },
    monthend: {
        code: 5,
        label: 'month_end'
    }
}

export const dateUnit = {
    days: {
        code: 'D',
        label: 'days'
    },
    months: {
        code: 'M',
        label: 'months'
    },
    years: {
        code: 'Y',
        label: 'years'
    }
}

export const dateFromToday = {
    afterToday: {
        code: 1,
        label: 'after_today'
    },
    beforeToday: {
        code: 2,
        label: 'before_today'
    },
    afterThisMonth: {
        code: 3,
        label: 'after_this_month'
    },
    beforeThisMonth: {
        code: 4,
        label: 'before_this_month'
    }
}
